import React from "react";

export default function Burger(props) {
  const { onClick, open } = props;

  const handleClick = (e) => onClick(e);

  return (
    <div className="burger-bun" onClick={handleClick}>
      <button
        data-testid="t-MenuBar-Complex--Burger-toggle-navigation-dr"
        className={open == true ? "burger burger-open" : "burger"}
        aria-label="Toggle navigation drawer"></button>
    </div>
  );
}
